import React from 'react';
import { Route } from "react-router-dom";
import CatchErrors from 'components/common/catch-errors';
import EmailBlast from 'components/dashboard/email-blast';
import MessagesTable from 'components/dashboard/messages-table';

export default function Main(props) {

    return (

        <div className='row'>
            {/* ----------------------------------------------------------------------
				COLUMN 1 - /company
			---------------------------------------------------------------------- */}

            <div id="column1" className="column col-3">
                <Route path={props.match.path} render={(route_props) =>
                    <>
                        <h1><strong>DASHBOARD</strong></h1>
                        <CatchErrors className={'m-t-3'}>
                            <EmailBlast />
                        </CatchErrors>
                        <CatchErrors className={'m-t-3'}>
                            <MessagesTable />
                        </CatchErrors>
                    </>
                } />
            </div>

            {/* ----------------------------------------------------------------------
				COLUMN 2 - /company/form
			---------------------------------------------------------------------- */}

            <div id="column2" className="column col-6" style={{ height: 'calc(100vh - 100px)', overflowY: 'scroll', overflowX: 'hidden' }}>
                {/* <Route path={ props.match.path + '/form' } render={ (route_props) =>
                    <CompanyForm />
                } /> */}
            </div>

            {/* ----------------------------------------------------------------------
				COLUMN 3 - /
			---------------------------------------------------------------------- */}

            {/* <div id="column3" className="col-2 bg-primary" style={ { height: 'calc(100vh - 100px)', overflow: 'hidden' } }>
                <Route path={ props.match.path } render={ (route_props) =>
                    <UserProfile />
                } />
            </div> */}
        </div>
    );
};

